import {createContext,useContext,type ReactNode} from 'react';
const AuthInitContext = createContext({isAuthInitialized:false});
export const useAuthInitialized = () => useContext(AuthInitContext);
export const AuthProvider = ({children}:{children:ReactNode}) => <>{children}</>;
export const WakaAuthReady = ({ready,children}:{ready:boolean;children:ReactNode}) =>
  <AuthInitContext.Provider value={{isAuthInitialized:ready}}>{children}</AuthInitContext.Provider>;
export const authFlagsFromPath = () => ({isPublicPath:false,isAuthPath:false});
